import React from 'react';
import styled from 'styled-components';

import Summary from './Summary';

import useProjectStore from '../../store-zustand/project';

const Wrapper = styled.details`
  margin: -1px -2.5rem 0;
  &[open] summary svg.chevron-right {
    transform: rotate(90deg);
  }

  &[open] h2 {
    color: #e5e5e5;
  }
`


const Accordion = ({ children, id, color, ...props }) => {

  const { project_id, AddAnnotation, setreloadAnnotationsList } = useProjectStore();
  //Add annotation
  const saveAnnotations = async (annotationobjects) => {


    var promise1 = new Promise(function (resolve, reject) {

      //Manage markers first
      annotationobjects.markers.map(async (obj, index) => {

        let saveStatus = await save_pin(obj, index);
        resolve(saveStatus);

      })

      //manage Polygons
      annotationobjects.polygons.map(async (obj, index) => {

        let saveStatus = await save_changes(obj, index, 'POLYGON');
        resolve(saveStatus);

      })

      //manage polyline
      annotationobjects.polylines.map(async (obj, index) => {

        let saveStatus = await save_changes(obj, index, 'POLYLINE');
        resolve(saveStatus);

      })

    });
    promise1.then(function (value) {

      //Refresh the list
      setreloadAnnotationsList(Math.floor(Math.random() * 1000) + 1);

      // expected output: "in map"
    });


  }


  //Send pins Data
  const save_pin = async (obj, index) => {
    let keyword = {};

    let lon = obj.lng;
    let lat = obj.lat;

    let shapeString = `POINT(${lon} ${lat})`;

    const LongitudeLatitude = `${lon}, ${lat}`

    //Get the Geometry
    keyword.annotationGeometry = shapeString;


    //Set annotation name and description

    //keyword.annotationName = `KML POINT : ${index}`;
    keyword.annotationName = obj.name;

    keyword.annotationDescription = LongitudeLatitude;

    //Get the annotation Type
    keyword.annotationType = 'Point';

    //Get Centroid
    keyword.annotationCentroid = LongitudeLatitude;

    //Get measurement in m / m²
    keyword.annotationInMeter = `none`;

    //get the annotation measurement choosed by the user
    keyword.annotationMeasurement = `none`;

    //get the annotation measurement unit choosed by the user
    keyword.annotationMeasurementUnit = `none`;

    //Get the Actual project Id
    keyword.projectId = project_id;


    let defaultStyle = `{
        "FillColor": "#FFFFFF",
        "FillTransparency": 0.35,
        "LineWidth": 5,
        "PinName": "defaultMarker.svg",
        "pinwidth": 30,
        "pinheight": 30,
        "PinColor": "#487BF2",
        "PinMarker":"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJtYXJrZXJfc2ltcGxlX2xhcmdlIj4NCjxnIGlkPSIjYW5ub3RhdGlvbi1tYXJrZXIiPg0KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTQ2LjI1IDI1LjVDNDYuMjUgMzEuOTI1IDQxIDM5Ljk3NSAzMC44NSA0OS4yNzVMMzAgNTAuMDI1TDI5LjE1IDQ5LjI1QzE5IDM5Ljk3NSAxMy43NSAzMS45MjUgMTMuNzUgMjUuNUMxMy43NSAxNS45IDIwLjggOC43NSAzMCA4Ljc1QzM5LjIgOC43NSA0Ni4yNSAxNS44NzUgNDYuMjUgMjUuNVoiIGZpbGw9IndoaXRlIi8+DQo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik0zMCA1QzQwLjUgNSA1MCAxMy4wNSA1MCAyNS41QzUwIDMzLjggNDMuMzI1IDQzLjYyNSAzMCA1NUMxNi42NzUgNDMuNjI1IDEwIDMzLjggMTAgMjUuNUMxMCAxMy4wNSAxOS41IDUgMzAgNVpNNDUgMjUuNUM0NSAxNi40MjUgMzguMzc1IDEwIDMwIDEwQzIxLjYyNSAxMCAxNSAxNi40MjUgMTUgMjUuNUMxNSAzMS4zNSAxOS44NzUgMzkuMSAzMCA0OC4zNUM0MC4xMjUgMzkuMSA0NSAzMS4zNSA0NSAyNS41Wk0zMCAzMEMyNy4yNSAzMCAyNSAyNy43NSAyNSAyNUMyNSAyMi4yNSAyNy4yNSAyMCAzMCAyMEMzMi43NSAyMCAzNSAyMi4yNSAzNSAyNUMzNSAyNy43NSAzMi43NSAzMCAzMCAzMFoiIGZpbGw9IiM0ODdCRjIiLz4NCjwvZz4NCjwvZz4NCjwvc3ZnPg0K",
        "Labelfontsize": "11px",
        "LabelfillColor": "#FFFFFF",
        "LabelVisibility": false,
        "Polygonoutlinecolor": "#3B6DBD"
      }`
    keyword.annotationStyle = defaultStyle;

    //Save the annotationz
    //console.log(keyword);
    const response = await AddAnnotation(keyword);
    if (response.length == 0) {
      return 'Error';
    }
    else {

      return 'Great';
      /*
      if (hidealerts == false) {
        alert('Annotation saved successfully');
      }
      //Clear point from global variable
      delete window['CurrentPointCentroid'];
      delete window['CurrentPointCentroidArrayFormat'];

      //Remove primitive
      viewer.scene.primitives.remove(window['CurrentPinMarker']);
      delete window['CurrentPinMarker'];
      //setdraw_state(true);


      //On editing style we don't have to add annotation to list so we don't get two features
      if (addannotationtoviewer) {
        //Force Annotation list to reload
        setcurrentAnnotationId(response[0].pk);
      }

      if (hidealerts == true) {
        return response[0];
      }
      */
    }

  }

  //send Area
  //Send back MEasurement data
  const save_changes = async (obj, index, geometryType) => {
    let keyword = {};
    //console.log(obj);
    //console.log(window.CurrentMeasureShape, window.CurrentMeasureShape['GeometryType']);
    //let geometryType = window.CurrentMeasureShape['GeometryType'];
    //REturn the shape fo DB
    //Prepare key string to convert
    let ArrayElementString = obj.map((obj, index) => {
      return `${obj.lng} ${obj.lat}`
    })

    let LongitudeLatitude = `${obj[0].lng}, ${obj[0].lat}`

    //Set annotation name and description
    if (geometryType == 'POLYLINE') {

      let shapeString = `LINESTRING(${ArrayElementString})`;

      //Get the Geometry
      keyword.annotationGeometry = shapeString;

      //Get the annotation Type
      keyword.annotationType = geometryType;

      //keyword.annotationName = `KML LINE : ${index}`;
      keyword.annotationName = obj[0].name;
      keyword.annotationDescription = LongitudeLatitude;

    } else {

      let shapeString = `POLYGON((${ArrayElementString}))`;

      //Get the Geometry
      keyword.annotationGeometry = shapeString;

      //Get the annotation Type
      keyword.annotationType = geometryType;
      //keyword.annotationName = `KML POLYGON : ${index}`;
      keyword.annotationName = obj[0].name;

      keyword.annotationDescription = LongitudeLatitude;

    }

    //Get Centroid
    keyword.annotationCentroid = LongitudeLatitude;

    //Get measurement in m / m²
    keyword.annotationInMeter = ``;

    //get the annotation measurement choosed by the user
    keyword.annotationMeasurement = ''

    keyword.annotationMeasurementUnit = ''

    //Get the Actual project Id
    keyword.projectId = project_id;

    let defaultStyle = `{
        "FillColor": "#FFFFFF",
        "FillTransparency": 0.35,
        "LineWidth": 5,
        "PinName": "defaultMarker.svg",
        "pinwidth": 30,
        "pinheight": 30,
        "PinColor": "#487BF2",
        "PinMarker":"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJtYXJrZXJfc2ltcGxlX2xhcmdlIj4NCjxnIGlkPSIjYW5ub3RhdGlvbi1tYXJrZXIiPg0KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTQ2LjI1IDI1LjVDNDYuMjUgMzEuOTI1IDQxIDM5Ljk3NSAzMC44NSA0OS4yNzVMMzAgNTAuMDI1TDI5LjE1IDQ5LjI1QzE5IDM5Ljk3NSAxMy43NSAzMS45MjUgMTMuNzUgMjUuNUMxMy43NSAxNS45IDIwLjggOC43NSAzMCA4Ljc1QzM5LjIgOC43NSA0Ni4yNSAxNS44NzUgNDYuMjUgMjUuNVoiIGZpbGw9IndoaXRlIi8+DQo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik0zMCA1QzQwLjUgNSA1MCAxMy4wNSA1MCAyNS41QzUwIDMzLjggNDMuMzI1IDQzLjYyNSAzMCA1NUMxNi42NzUgNDMuNjI1IDEwIDMzLjggMTAgMjUuNUMxMCAxMy4wNSAxOS41IDUgMzAgNVpNNDUgMjUuNUM0NSAxNi40MjUgMzguMzc1IDEwIDMwIDEwQzIxLjYyNSAxMCAxNSAxNi40MjUgMTUgMjUuNUMxNSAzMS4zNSAxOS44NzUgMzkuMSAzMCA0OC4zNUM0MC4xMjUgMzkuMSA0NSAzMS4zNSA0NSAyNS41Wk0zMCAzMEMyNy4yNSAzMCAyNSAyNy43NSAyNSAyNUMyNSAyMi4yNSAyNy4yNSAyMCAzMCAyMEMzMi43NSAyMCAzNSAyMi4yNSAzNSAyNUMzNSAyNy43NSAzMi43NSAzMCAzMCAzMFoiIGZpbGw9IiM0ODdCRjIiLz4NCjwvZz4NCjwvZz4NCjwvc3ZnPg0K",
        "Labelfontsize": "11px",
        "LabelfillColor": "#FFFFFF",
        "LabelVisibility": false,
        "Polygonoutlinecolor": "#3B6DBD"
      }`
    keyword.annotationStyle = defaultStyle;

    //Save the annotation
    const response = await AddAnnotation(keyword);
    //console.log(response);
    if (response.length == 0) {

      return 'Error';

    }
    else {

      return 'Great';
    }

    //console.log(keyword);
  }

  const onAdd = (file) => {
    //console.log(file);
    const fileReader = new FileReader();
    fileReader.addEventListener('load', (event) => {

      let result = extractGoogleCoords(event.target.result);
      saveAnnotations(result);

    });


    fileReader.readAsText(file);

    const extractGoogleCoords = (plainText) => {

      let parser = new DOMParser()
      let xmlDoc = parser.parseFromString(plainText, "text/xml")
      let googlePolygons = []
      let googlePolylines = []
      let googleMarkers = []

      if (xmlDoc.documentElement.nodeName == "kml") {

        for (const item of xmlDoc.getElementsByTagName('Placemark')) {
          let placeMarkName = item.getElementsByTagName('name')[0].childNodes[0].nodeValue.trim()
          //console.log(placeMarkName);
          let polygons = item.getElementsByTagName('Polygon')
          let markers = item.getElementsByTagName('Point')
          let polylines = item.getElementsByTagName('LineString')

          /** POLYGONS PARSE **/
          for (const polygon of polygons) {
            let coords = polygon.getElementsByTagName('coordinates')[0].childNodes[0].nodeValue.trim()
            let points = coords.split(" ")

            let googlePolygonsPaths = []
            for (const point of points) {
              let coord = point.split(",")
              googlePolygonsPaths.push({ lat: +coord[1], lng: +coord[0], name: placeMarkName })
            }
            googlePolygons.push(googlePolygonsPaths)
          }

          /** Polyline parse **/
          for (const polyline of polylines) {
            let coords = polyline.getElementsByTagName('coordinates')[0].childNodes[0].nodeValue.trim()
            let points = coords.split(" ")

            let googlePolylinePaths = []
            for (const point of points) {
              let coord = point.split(",")
              googlePolylinePaths.push({ lat: +coord[1], lng: +coord[0], name: placeMarkName })
            }
            googlePolylines.push(googlePolylinePaths)
          }
          /** MARKER PARSE **/
          for (const marker of markers) {
            var coords = marker.getElementsByTagName('coordinates')[0].childNodes[0].nodeValue.trim()
            let coord = coords.split(",")
            googleMarkers.push({ lat: +coord[1], lng: +coord[0], name: placeMarkName })
          }
        }
      } else {
        throw "error while parsing"
      }

      return { markers: googleMarkers, polygons: googlePolygons, polylines: googlePolylines }
    }
  }

  return (
    <Wrapper {...props}>
      <Summary {...props} id={id} color={color} onAdd={!!props.onAdd ? props.onAdd : onAdd} />
      {children}
    </Wrapper>
  );
}

export default Accordion;